import React from 'react';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { CategoryTreeItem } from '@zonofi/zono-money-store';

interface RenderCategoriesProps {
  categories: CategoryTreeItem[];
  handleCategoryClick: (category: CategoryTreeItem) => void;
  selectedCategories: CategoryTreeItem[];
}

export const RenderCategories: React.FC<RenderCategoriesProps> = ({
  categories,
  handleCategoryClick,
  selectedCategories,
}) => {
  return categories?.map((category, id) => (
    <button
      key={category?.id}
      className={`category-button font-medium ${
        selectedCategories.find((c) => c?.id === category?.id) ? 'selected' : ''
      }`}
      onClick={() => handleCategoryClick(category)}
    >
      {category?.name}
      {category?.children && category?.children?.length > 0 && (
        <KeyboardArrowRightIcon fontSize="small" />
      )}
    </button>
  ));
};
